import React, { useEffect } from 'react';
import { getFirestore, doc, getDoc, collection, getDocs, query, where, or } from 'firebase/firestore';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { SchoolInfo } from '..';

type Props = {
  onResolved: (state: SchoolState) => void;
};

type SchoolState = {
  schoolId: string;
  schoolName: string;
  contract: boolean;
  schoolInfo: SchoolInfo | null;
};

const SchoolInitializer: React.FC<Props> = ({ onResolved }) => {
  const auth = getAuth();
  const db = getFirestore();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (!user) return;

      // schools.owner は通常は単一uid文字列だが、運営メンバーにもアクセスを許可した
      // 学校だけ配列([元のuid, 追加のuid, ...])になっているため両方にマッチさせる。
      const q = query(
        collection(db, "schools"),
        or(where("owner", "==", user.uid), where("owner", "array-contains", user.uid))
      );
      const snap = await getDocs(q);
      if (snap.empty) return;

      const docSnap = snap.docs[0];
      const schoolId = docSnap.id;
      const schoolName = docSnap.data().name;

      const schoolRef = doc(db, "schools", schoolId);
      const schoolDoc = await getDoc(schoolRef);

      const infoRef = doc(db, "info", "schoolInfo");
      const infoSnap = await getDoc(infoRef);
      const infoData = infoSnap.data()?.[schoolName] ?? null;

      console.log(schoolName);

      onResolved({
        schoolId,
        schoolName,
        contract: schoolDoc.data()?.contract ?? false,
        schoolInfo: infoData
          ? { id: infoData.id, departments: infoData.departments ?? {} }
          : null,
      });
    });

    return () => unsubscribe();
  }, []);

  return null;
};

export default SchoolInitializer;